export default __webpack_public_path__ + "static/media/hello-beer-logo.f2c86210.svg";